import { FEATURE_FLAGS } from "@repo/core/constants/featureFlags";
import { PROPOSAL_ACTIONS } from "@repo/core/constants/proposals";

export interface ProposalFeatureFlags {
  enableCreditTable: boolean;
}

export const isProposalActionEnabled = (
  action: PROPOSAL_ACTIONS,
  featureFlags: ProposalFeatureFlags = FEATURE_FLAGS
): boolean =>
  action !== PROPOSAL_ACTIONS.SEND_TO_CREDIT_TABLE ||
  featureFlags.enableCreditTable;

export const filterEnabledProposalActions = <
  T extends { action: PROPOSAL_ACTIONS }
>(
  options: T[],
  featureFlags: ProposalFeatureFlags = FEATURE_FLAGS
): T[] =>
  options.filter((option) =>
    isProposalActionEnabled(option.action, featureFlags)
  );
